import { render, staticRenderFns } from "./ImotList.vue?vue&type=template&id=5920921e&scoped=true"
import script from "./ImotList.vue?vue&type=script&lang=js"
export * from "./ImotList.vue?vue&type=script&lang=js"
import style0 from "./ImotList.vue?vue&type=style&index=0&id=5920921e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920921e",
  null
  
)

export default component.exports